import React from "react";
import ProvidersList from "ComponentsUI/ProvidersList";
import { PROVIDERS_QUERY_RATES_PAGE } from "Services/queries";
import Routes from "Configs/routes";
import PaginationContainer from "Containers/PaginationContainer";
import { generateUrl } from "Services/withDefaultParams";
import { PaddingBottom, NoContainer } from "ComponentsUI/Spacings";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import { StubTariffsTags } from "ComponentsUI/Stub";
import { useParams, withRouter } from "react-router-dom";
import useDefaultParams from "Services/useDefaultParams";
import { useQuery } from "@apollo/client";
import { inject } from "mobx-react";

const LIMIT = 32;
function ProvidersContainer(props) {
	const routerParams = useParams();
	const defaultParams = useDefaultParams(routerParams);
	let page = 1;
	if (routerParams.page) {
		page = +routerParams.page;
	}
	const sort = "-vip_provider,vip_b2c_priority,-rating.expert.final,name";
	const filters = [];

	if (defaultParams.regionUrl) {
		filters.push(`region.url=${defaultParams.regionUrl}`);
	}
	const providersQuery = useQuery(PROVIDERS_QUERY_RATES_PAGE, {
		skip: !defaultParams.regionUrl,
		variables: {
			filter: filters.join("&"),
			limit: LIMIT,
			offset: page > 0 ? LIMIT * (page - 1) : 0,
			sort: sort,
		},
	});
	if (providersQuery.loading) return <StubTariffsTags />;

	if (+routerParams.page === 1) {
		return <RedirectPagination />;
	}
	if (!page || providersQuery.data.providers.pagination.items_total < LIMIT * (page - 1)) {
		return (
			<Redirect404 message404={"Выбрана пагинация больше доступной в тарифах региона без тега"} />
		);
	}
	const text = props.ApplicationModel.text;
	const windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
	const pagination = providersQuery.data.providers.pagination;
	let providers = JSON.parse(JSON.stringify(providersQuery.data.providers.data));
	providers.forEach((provider) => {
		provider.linkProviderSelect = generateUrl(Routes.ProviderDetails.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});
		provider.linkproviderRates = generateUrl(Routes.ProviderRates.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});
		provider.linkProviderReviews = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: provider.region.url,
			providerName: provider.url_name,
		});
		provider.linkProviderConnect = generateUrl(Routes.OrderHome.route, {
			regionUrl: provider.region.url,
		});
	});
	return (
		<NoContainer>
			<div>
				<PaddingBottom>
					<ProvidersList
						{...props}
						text={text}
						windowSize={windowSizes}
						items={providers}
						flat={false}
						ratesView={true}
						isRatesAddForm={true}
						catalogProviders={props.isProviderCatalog}
					/>
				</PaddingBottom>
				<PaginationContainer
					generationUrl={Routes.Providers.route}
					pagination={pagination}
					limit={LIMIT}
				/>
			</div>
		</NoContainer>
	);
}
export default withRouter(inject("ApplicationModel")(ProvidersContainer));
